import { useContext } from "react";

import { IdentityClientContext } from "../../contexts";

export const useIdentityClient = () => {
	return useContext(IdentityClientContext);
};
